import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { 
  IconButton, 
  Menu, 
  MenuItem,
  Typography
} from '@mui/material';
import { Language } from '@mui/icons-material';
import i18n from '../i18n'; // 直接导入 i18n 实例

const LanguageSwitcher = () => {
  const { t } = useTranslation(); // 只使用 t 函数
  const [anchorEl, setAnchorEl] = useState(null);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng); // 使用导入的 i18n 实例
    handleClose();
  };

  const currentLang = i18n.language || 'en';

  return (
    <>
      <IconButton 
        color="inherit" 
        onClick={handleClick}
        size="small"
        aria-controls="language-menu"
        aria-haspopup="true"
      >
        <Language />
        <Typography variant="body2" sx={{ ml: 0.5 }}>
          {currentLang === 'zh' ? '中文' : 'EN'}
        </Typography>
      </IconButton>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem 
          onClick={() => changeLanguage('en')}
          selected={currentLang === 'en'}
        >
          English
        </MenuItem>
        <MenuItem 
          onClick={() => changeLanguage('zh')}
          selected={currentLang === 'zh'}
        >
          中文
        </MenuItem>
      </Menu>
    </>
  );
};

export default LanguageSwitcher; 